import type { ColumnDef } from "@tanstack/react-table";
import type { Jurusan } from "../api/get-jurusan";

export const columnsJurusan: ColumnDef<Jurusan>[] = [
  {
    accessorKey: 'kode_jurusan',
    header: 'Kode Jurusan',
  },
  {
    accessorKey: 'nama_jurusan',
    header: 'Nama Jurusan',
  },
  {
    accessorKey: 'program',
    header: 'Program',
  },
  {
    accessorKey: 'kode_fakultas',
    header: 'Kode Fakultas',
  },
];
